import ResizableScene from "../core/ResizableScene";

export default class Overlay extends Phaser.GameObjects.Sprite {
	_resize: () => void;

	constructor(scene: ResizableScene, alpha = 0.8, texture = "whiteSquare", tint = 0x000000) {
		super(scene, 0, 0, texture);

		this.tint = tint;
		this.alpha = alpha;
		scene.input.enable(this);

		this._resize = (): void => {
			this.setSize(scene.viewport.width, scene.viewport.height);
			this.setDisplaySize(scene.viewport.width, scene.viewport.height);
			scene.alignIn.Center(this, scene.viewport);
		};

		this.resize();
	}

	resize(): void {
		if (this._resize) this._resize();
	}
}
